<span>
  <ng-content></ng-content>
</span>
<div class="spinner-grow spinner-grow-sm" role="status" *ngIf="busy">
  <span class="sr-only">Loading...</span>
</div>
